<div class="coverImage">
  <div class="logo">
    <a routerLink="/"><img src="../../assets/images/logo.png" alt="logo" /></a>
  </div>
  <div class="slider">
    <div class="slider-contentBox">
      <owl-carousel-o [options]="customOptions">
        @for (slide of sliderData; track slide.name) {
          <ng-template class="slider" carouselSlide>
            <div class="slider-content">
              <p>{{ slide.heading }}</p>
              <cite class="author">{{ slide.name }}</cite>
            </div>
          </ng-template>
        }
      </owl-carousel-o>
    </div>
  </div>
  <div></div>
</div>
